import Vue from 'vue'
import VueRouter from 'vue-router'
import {authGuard} from "../auth"
import TrainingClass from "../views/TrainingClass"
import Home from "../views/Home"
import Speedy from "../views/Speedy"
import Debtors from "../views/Debtors"
import Dashboard from "../layouts/Dashboard"
import Settings from "../views/Settings"
import Emails from "../views/Emails"
import EmailView from "../views/EmailView"
import Users from "../views/Users/Index"
import UserCreate from "../views/Users/Create"

import authRoutes from "./routes/auth"
import bookingRoutes from "./routes/booking"
import trainerRoutes from "./routes/trainer"
import customerRoutes from "./routes/customer"
import leadRoutes from "./routes/leads"
import purchaseOrderRoute from "./routes/purchase-order"

import VueMeta from 'vue-meta'
Vue.use(VueMeta)
Vue.use(VueRouter)

let routes = [
    {
        path: '/',
        redirect: '/dashboard'
    },
    {
        path: '/dashboard',
        name: 'home',
        component: Home,
        beforeEnter: authGuard,
        meta: { layout: Dashboard },
    },
    {
        path: '/speedy',
        name: 'speedy',
        component: Speedy,
        beforeEnter: authGuard,
        meta: { layout: Dashboard },
    },
    {
        path: '/class/:id',
        name: 'training-class',
        component: TrainingClass,
        beforeEnter: authGuard,
        meta: { layout: Dashboard },
    },

    {
        path: '/debtors',
        name: 'debtors',
        component: Debtors,
        beforeEnter: authGuard,
        meta: { layout: Dashboard },
    },
    {
        path: '/settings',
        name: 'settings',
        component: Settings,
        beforeEnter: authGuard,
        meta: { layout: Dashboard },
    },
    {
        path: '/emails',
        name: 'emails',
        component: Emails,
        beforeEnter: authGuard,
        meta: { layout: Dashboard },
    },
    {
        path: '/email/:id',
        name: 'email-view',
        component: EmailView,
        beforeEnter: authGuard,
        meta: { layout: Dashboard },
    },
    {
        path: '/users',
        name: 'users',
        component: Users,
        beforeEnter: authGuard,
        meta: { layout: Dashboard },
    },
    {
        path: '/user/create',
        name: 'user-create',
        component: UserCreate,
        beforeEnter: authGuard,
        meta: { layout: Dashboard },
    },

]

routes = routes.concat(
    authRoutes,
    bookingRoutes,
    trainerRoutes,
    customerRoutes,
    leadRoutes,
    purchaseOrderRoute,
)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
